/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate, useRouteError } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import styles from './errorPage.module.scss';
import { Button } from '../button/button';

export function ErrorPage() {
  const error: any = useRouteError();
  const navigator = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.errorContainer}>
      <CancelIcon sx={{ fill: 'red' }} fontSize="large" />
      <Typography variant="h4">{t('GENERIC_ERROR')}</Typography>
      <span>
        <Trans
          i18nKey="CONTACT_SUPPORT"
          components={{
            primary: <a href="mailto:support@hitiq.co" />,
          }}
        />
      </span>
      <p>
        <i>{error?.statusText || error?.message}</i>
      </p>
      <Button
        color="secondary"
        type="button"
        variant="contained"
        onClick={() => navigator('/')}
        label={t('GO_TO_HOME_DASHBOARD').toString()}
      />
    </div>
  );
}
